import AppSearch from './AppSearch/AppSearch';
import AppSelect from './AppSelect/AppSelect';
import AppTextFields from './TextFields';

import AppSwitch from './AppSwitch';
import AppControlledSwitch from './AppControlledSwitch';
import AppCheckbox from './AppCheckbox';
import AppRadioButton from './AppRadioButton';
import AppTimePickerMenu from './AppTimePickerMenu';
import AppDatePickerMenu from './AppDatePickerMenu';
import AppSlider from './AppSlider';
import AppFileUpload from './AppFileUpload';

export default {
	AppSearch,
	AppSelect,
	...AppTextFields,
	AppSwitch,
	AppControlledSwitch,
	AppCheckbox,
	AppRadioButton,
	AppTimePickerMenu,
	AppDatePickerMenu,
	AppSlider,
	AppFileUpload,
};
